import React from "react";

const ORDER_STEPS = [
  "Order Placed",
  "Payment Confirmed",
  "Processing",
  "Shipped",
  "Out for Delivery",
  "Delivered",
];

export default function OrderStatusStepper({ currentStep = 0, timeline = [] }) {
  return (
    <div className="w-full my-6">
      <div className="flex flex-col md:flex-row items-center md:justify-between">
        {ORDER_STEPS.map((step, idx) => (
          <div key={step} className="flex-1 flex flex-col items-center">
            <div
              className={`w-8 h-8 rounded-full flex items-center justify-center font-bold text-white mb-2
                ${idx < currentStep ? "bg-green-500" : idx === currentStep ? "bg-blue-600" : "bg-gray-300"}`}
            >
              {idx < currentStep ? <span>&#10003;</span> : idx + 1}
            </div>
            <span className={`text-xs md:text-sm text-center ${idx === currentStep ? "font-bold text-blue-700" : "text-gray-600"}`}>{step}</span>
            {idx < ORDER_STEPS.length - 1 && (
              <div className="hidden md:block w-full h-1 bg-gray-200 my-2">
                <div
                  className={`h-1 ${idx < currentStep ? "bg-green-500" : "bg-gray-200"}`}
                  style={{ width: "100%" }}
                ></div>
              </div>
            )}
          </div>
        ))}
      </div>
      {/* Timeline */}
      {timeline && timeline.length > 0 && (
        <div className="mt-6 bg-gray-50 rounded-lg p-4">
          <h4 className="font-semibold mb-2 text-gray-700">Order Timeline</h4>
          <ul className="text-sm text-gray-600 space-y-1">
            {timeline.map((item, idx) => (
              <li key={idx}>
                <span className="font-medium text-gray-800">{item.status}:</span>{' '}
                {item.time || (item.at ? new Date(item.at).toLocaleString() : '')}
              </li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
}
